import React from "react"
import  {MainCP}  from "../../../Components/enusc/enusc-v2/MainCP"

const ViewEnusc: React.FC = () => <MainCP/>
export default ViewEnusc
